import { sendGoogleAnalyticsEvent } from './google-analytics';
import Logger from '../logger';

const sendEvent = (eventName, args) => {
    try {
        sendGoogleAnalyticsEvent(eventName, args);
    } catch (error) {
        Logger.error(`sendEvent error=${error.message}`);
    }
};

export { sendEvent };
